import React from 'react';
import { observer } from 'mobx-react';

import { RenderNode } from 'libs/editor/plugins/helpers/renderNode';
import { HasNode } from 'libs/editor/plugins/helpers/hasNode';

import { HeaderMargin } from './styles';

const HeaderFourNode = observer(({ attributes, children }) => (
  <HeaderMargin
    textTransform='uppercase'
    marginBottom
    level={4}
    size='xsmall'
    {...attributes}
  >
    {children}
  </HeaderMargin>
));

const type = 'header_four';
const active = value => HasNode(type, value);

export function HeaderFour() {
  return {
    button: {
      elementType: 'node',
      type,
      active,
      handleClick: store => {
        const { value, reference, onChange } = store;
        if (active(value)) {
          reference.setBlocks('paragraph');
        } else {
          reference.setBlocks(type);
        }
        onChange(reference);
      },
    },
    plugins: [RenderNode(type, props => <HeaderFourNode {...props} />)],
  };
}
